$(document).on('mousedown', '.js-clickable', function(e){
    switch(e.which) {
        case 1:
            if(!$(e.target).closest('a:not(.js-clickable-link)').length){
                window.location = $(this).find(".js-clickable-link").attr("href");
                return false;
            }
            break;
        case 2:
            if(!$(e.target).closest('a:not(.js-clickable-link)').length){
                window.open($(this).find(".js-clickable-link").attr("href"), '_blank');
                return false;
            }
            break;
    }
    return true; // to allow the browser to know that we handled it.
});
